import {
  Autocomplete,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';

import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { GlobalVariables } from '../../../globalVar';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { MuiTelInput } from 'mui-tel-input';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import moment from 'moment';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';

function ModalT(props) {
  const {
    phoneCountryStr,
    techBirthDateString,
    notesString,
    jobString,
    techEntryDateString,
  } = useTranslationHook();

  const weakPWErrorAlert = (missingRequirements) => {
    toast.dismiss();
    if (missingRequirements.length > 0) {
      toast.error(
        'La contraseña ingresada es débil. No cumple con los siguientes requisitos:',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        },
      );

      missingRequirements.forEach((requirement) => {
        toast.info(`${requirement}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPW] = useState('');
  const [verifyPassword, setVPW] = useState('');
  const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('MX');
  const [birthDate, setBirthDate] = useState(moment());
  const [entryDate, setEntryDate] = useState(moment());
  const [notes, setNotes] = useState('');
  const [job, setJob] = useState('');

  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [roles, setRoles] = useState([]);
  const [roleId, setRoleId] = useState(null);

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!props.show) return;

    fetchData();
  }, [props.show]);

  const fetchData = async () => {
    setIsFetching(true);

    try {
      const [clientsData, rolesData] = await Promise.all([
        fetchClients(),
        fetchRoles(),
      ]);

      setClients(clientsData);
      setRoles(rolesData);
    } catch (error) {
      console.error(error);
      getToast({
        status: 'error',
        title: 'Error al obtener los datos.',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const fetchClients = async () => {
    const endpoint = `${GlobalVariables.getURL()}listClients/`;
    const response = await customAxios.get(endpoint, {
      headers: {
        Authorization: 'bearer ' + localStorage.getItem('token'),
      },
    });

    if (response.status !== 200) return [];

    return response.data;
  };

  const fetchRoles = async () => {
    const endpoint = `${GlobalVariables.getURL()}roles/listTechRoles/`;
    const response = await customAxios.get(endpoint, {
      headers: {
        Authorization: 'bearer ' + localStorage.getItem('token'),
      },
    });

    if (response.status !== 200) return [];

    return response.data;
  };

  const resetFields = () => {
    setEmail('');
    setName('');
    setLastName('');
    setPW('');
    setVPW('');
    setPhone('');
    setCountryCode('MX');
    setBirthDate(moment());
    setEntryDate(moment());
    setNotes('');
    setJob('');
    setRoleId(null);
    setSelectedClients([]);
  };

  function hide() {
    resetFields();
    props.onHide();
    toast.dismiss();
    getToast({
      status: 'success',
      title: 'Técnico creado exitosamente en la base de datos.',
    });
    props.getTechs();
  }

  function createTech(event) {
    event.preventDefault();
    setIsLoading(true);
    const userClients = selectedClients.map((client) => client.id);
    if (password === verifyPassword) {
      const data = {
        name: name,
        last_names: lastName,
        email: email,
        password: password,
        telefono: phone,
        countryCode: countryCode,
        fechaNacimiento: birthDate.toISOString(),
        notes,
        roles_id: roleId,
        clients: userClients,
        job,
        entry_date: entryDate.toISOString(),
      };
      customAxios
        .post(`${GlobalVariables.getURL()}createTech`, data, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then(
          (response) => {
            hide();
          },
          (error) => {
            console.log(error);
            const errorData = error.response?.data;

            if (errorData === 'Fecha invalida.') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'La fecha de nacimiento no es válida. Vuelve a intentarlo.',
              });
            } else if (
              errorData?.message &&
              typeof errorData.message === 'string' &&
              errorData.message.startsWith('Licencias insuficientes')
            ) {
              toast.dismiss();
              getToast({
                status: 'error',
                title: errorData.message,
              });
            } else if (
              typeof errorData === 'string' &&
              errorData.startsWith('Contraseña débil.')
            ) {
              const requirements = [
                'Debe contener al menos una letra mayúscula.',
                'Debe contener al menos un número.',
                'Debe contener al menos un caracter especial (!@#$%^&*).',
                'Debe tener al menos 9 caracteres de longitud.',
              ];

              const missingRequirements = requirements.filter((requirement) =>
                errorData.includes(requirement),
              );

              weakPWErrorAlert(missingRequirements);
            } else if (errorData === 'Usuario ya existe.') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'Ya existe un técnico con esta información. Vuelve a intentarlo.',
              });
            } else {
              toast.dismiss();
              getToast({
                status: 'error',
                title: 'Error al crear técnico. Vuelve a intentarlo.',
              });
            }
          },
        )
        .finally(() => setIsLoading(false));
    } else {
      toast.dismiss();
      getToast({
        status: 'error',
        title: 'Contraseñas no coinciden. Vuelve a intentarlo.',
      });
      setIsLoading(false);
    }
  }

  return (
    <Modal
      show={props.show}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      backdropClassName='modal-backdrop'
      centered
      onHide={() => {
        resetFields();
        props.onHide();
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Nuevo técnico
        </Modal.Title>
      </Modal.Header>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={moment.locale()}
      >
        <Modal.Body>
          <form id='techs-form' onSubmit={createTech}>
            <div className='row'>
              <div className='col-md-12'>
                <TextField
                  sx={{ width: '100%' }}
                  label='Correo electrónico'
                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-6'>
                <TextField
                  sx={{ width: '100%' }}
                  label='Nombre(s)'
                  type='text'
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className='col-md-6'>
                <TextField
                  sx={{ width: '100%' }}
                  label='Apellido(s)'
                  type='text'
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-6'>
                <TextField
                  sx={{ width: '100%' }}
                  label={jobString}
                  type='text'
                  value={job}
                  onChange={(e) => setJob(e.target.value)}
                />
              </div>
              <div className='col-md-6'>
                <DatePicker
                  sx={{ width: '100%' }}
                  label='Fecha de Ingreso'
                  type='date'
                  value={entryDate}
                  onChange={(newDate) => {
                    setEntryDate(newDate);
                  }}
                />
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-6'>
                <Tooltip
                  title='Mínimo 9 caracteres (una mayúscula, un número y un caracter especial).'
                  arrow
                >
                  <TextField
                    sx={{ width: '100%' }}
                    label='Contraseña'
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPW(e.target.value)}
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            onClick={handleClickShowPassword}
                            edge='end'
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? (
                              <VisibilityOffOutlinedIcon />
                            ) : (
                              <VisibilityOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Tooltip>
              </div>
              <div className='col-md-6'>
                <Tooltip
                  title='Mínimo 9 caracteres (una mayúscula, un número y un caracter especial).'
                  arrow
                >
                  <TextField
                    sx={{ width: '100%' }}
                    label='Repetir contraseña'
                    type={showPassword ? 'text' : 'password'}
                    value={verifyPassword}
                    onChange={(e) => setVPW(e.target.value)}
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            onClick={handleClickShowPassword}
                            edge='end'
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? (
                              <VisibilityOffOutlinedIcon />
                            ) : (
                              <VisibilityOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Tooltip>
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-12'>
                <Autocomplete
                  disabled={isLoading}
                  options={roles}
                  value={roles.find((r) => r.id === roleId) || null}
                  getOptionLabel={(role) => role.role_name || ''}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(_, newValue) =>
                    setRoleId(newValue ? newValue.id : null)
                  }
                  renderInput={(params) => (
                    <TextField
                      name='role_id'
                      required
                      {...params}
                      label={'Rol'}
                      placeholder={`Rol...`}
                    />
                  )}
                />
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-12'>
                <Autocomplete
                  multiple
                  filterSelectedOptions
                  sx={{ width: '100%' }}
                  options={clients}
                  value={selectedClients}
                  getOptionLabel={(client) => client.business_name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(_, newValue) => {
                    setSelectedClients(newValue ? newValue : null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={'Plazas'}
                      placeholder={'Plazas...'}
                      required={selectedClients.length === 0}
                    />
                  )}
                  isLoading={isFetching}
                />
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-6'>
                <MuiTelInput
                  sx={{ width: '100%' }}
                  label='Teléfono'
                  defaultCountry={countryCode}
                  langOfCountryName={phoneCountryStr}
                  value={phone}
                  onChange={(newPhone, info) => {
                    setPhone(newPhone);
                    setCountryCode(info.countryCode);
                  }}
                  forceCallingCode
                  disableFormatting
                  required
                />
              </div>
              <div className='col-md-6'>
                <DatePicker
                  sx={{ width: '100%' }}
                  label={techBirthDateString}
                  type='date'
                  value={birthDate}
                  onChange={(newDate) => {
                    setBirthDate(newDate);
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                    },
                  }}
                />
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-12'>
                <TextField
                  sx={{ width: '100%' }}
                  label={notesString}
                  type='text'
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
      </LocalizationProvider>
      <Modal.Footer>
        <Button
          type='submit'
          form='techs-form'
          className='save-modal-button'
          variant='contained'
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalT;
